const SPLASH_SPEED_KEY = "splashSpeed";

export const MIN_SPLASH_SPEED = 1;
export const MAX_SPLASH_SPEED = 2.5;
export const DEFAULT_SPLASH_SPEED = 1;

export const getSplashSpeed = () => {
    const stored = Number(localStorage.getItem(SPLASH_SPEED_KEY));
    if (!stored || stored < MIN_SPLASH_SPEED || stored > MAX_SPLASH_SPEED) {
        return DEFAULT_SPLASH_SPEED;
    }
    return stored;
};

export const saveSplashSpeed = (speed) => {
    localStorage.setItem(SPLASH_SPEED_KEY, String(speed));
};
